import { render, staticRenderFns } from "./text-field-column-basic.component.vue?vue&type=template&id=f0e16a7e&scoped=true&"
import script from "./text-field-column-basic.component.vue?vue&type=script&lang=ts&"
export * from "./text-field-column-basic.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-field-column-basic.component.vue?vue&type=style&index=0&id=f0e16a7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0e16a7e",
  null
  
)

export default component.exports